module.exports = __webpack_public_path__ + "img/REGISTRO 1.1.bacdbefa.png";